import tenantConstants from '@constants';
import tenantPayloads from '@payloads';
import tenantTransformers from '@transformers';
import { convertQueryObjToString } from '../../../utility/urlQuery';

const postNewListingEndpoints = {
  postNewListing: {
    query: ({ userId, values, listing, autoRenew, productId, source, creditsInfo }) => {
      const payload = tenantPayloads.getUpdateListingPayload({
        userId,
        values,
        listing,
        autoRenew,
        productId,
        source,
        creditsInfo,
      });
      return { url: `/api/listings`, method: 'POST', body: payload };
    },
  },
  getAutoGeneratedListingContent: {
    query: (body) =>
      `/api/listings/generate_content?${convertQueryObjToString(tenantPayloads.autoGeneratedListingContentPayload(body))}`,
  },
  getAmenities: {
    query: () => {
      return {
        url: `/api/amenities`,
      };
    },
    transformer: (response) => tenantTransformers.amenitiesDataMapper(response?.amenities),
  },
  getQualityCriteria: {
    query: () => {
      return {
        url: `/api/listings/listing_score_metrics`,
      };
    },
    transformer: (response) => {
      return response?.score_metrics;
    },
  },

  getPriceCheck: {
    query: ({ values }) => {
      const areaUnitSlug = tenantData.areaUnitList.find((e) => e.id === values.area.unit)?.slug;
      const payload = {
        location_id: values.location_select?.location.location_id,
        type_id: values.property_type,
        purpose_id: values.purpose,
        area: (values.area.value * tenantData.areaMapings[areaUnitSlug]['square_feet']).toFixed(0),
        price: values?.monthly_rent.value ? values?.monthly_rent?.value : values.price.value,
      };
      return { url: `/api/listings/price_check`, body: payload };
    },
  },
  getListingDetail: {
    query: ({ listingId }) => {
      return {
        url: `/api/listings/${listingId}/edit`,
      };
    },
    transformer: (response) => {
      const listing = response?.listing;
      const residenceTypes = response?.residence_types;
      listing.images = listing.images?.sort((image1, image2) => image1.order - image2.order);
      return {
        listing: listing
          ? {
              ...listing,
              location: { ...listing?.location, breadcrumb: listing?.location?.breadcrumb?.reverse() },
              platform: {
                ksa: tenantTransformers.postedToBayut(listing?.status?.name),
              },
              listingPrice: { value: listing?.price, currency: tenantConstants.CURRENCY },
              residenceTypes,
            }
          : listing,
      };
    },
  },
  updateListing: {
    query: ({ values, listing, autoRenew, productId, source }) => {
      const payload = tenantPayloads.getUpdateListingPayload({ values, listing, autoRenew, productId, source });
      return { url: `/api/listings/${values?.id}`, method: 'PUT', body: payload };
    },
  },
};

export default postNewListingEndpoints;
